import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { PropsWithChildren } from 'react';
import { Button, Card } from 'react-bootstrap';
import styled from 'styled-components';

const BackButton = styled(Button)`
  position: absolute;
  font-weight: 800;
  text-decoration: none;
  padding: 0;
  align-items: center;
  justify-content: center;
  display: flex;

  .svg-inline--fa {
    font-weight: 800;
    font-size: 22px;
    margin-right: 5px;
  }
`;

interface LoginCardProps {
  onBack?: (...args: unknown[]) => unknown;
}

const LoginCard = ({ children, onBack }: PropsWithChildren<LoginCardProps>) => {
  return (
    <Card className="p-3 p-sm-4 text-center">
      {!!onBack && (
        <BackButton variant="link" onClick={onBack}>
          <FontAwesomeIcon icon={faChevronLeft} /> Back
        </BackButton>
      )}
      {children}
    </Card>
  );
};

export default LoginCard;
